import styled from 'styled-components';
import { Card, Container, Row, Image } from 'react-bootstrap';
import InstituteLogo from 'assets/images/institute-logo.png';
import { device } from 'helpers/screen';

const Holder = styled(Container)`
    background-color: #424250;
    position: absolute;
    top: 0;
    bottom: 0;
`;

const Topbar = styled.div`
	background-color: #0278ee;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	padding: 0.8rem 2rem;

	& > span {
		font-weight: 500;
		color: white;
	}
	& span:first-child {
		font-size: 23pt;
	}
	& span:last-child {
		font-size: 13pt;
	}
`;

const LoginCard = styled(Card)`
    border: none;
    border-radius: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 40vw;
    padding: ${(props) => props.tp ? props.tp : '0'} 10vw 1.5rem 10vw;
    margin: 7rem auto;
    gap: 1.1rem;

	@media ${device.max.tablet} {
		padding: 6rem 5vw 1.5rem 5vw;
		width: 55vw;
	}
`;

const LogoCircle = styled.div`
	background-color: white;
	width: 7rem;
	height: 7rem;
	border-radius: 3.5rem;
	position: absolute;
	top: -4rem;
	margin: 0 auto;
	display: flex;
	align-items: center;
	justify-content: center;
	box-shadow: 10px 9px 46px -10px rgba(0, 0, 0, 0.75);
`;

const DesignerText = styled.span`
	color: white;
	position: absolute;
	bottom: 1rem;
	left: 2rem;
	text-align: center;
	font-size: 13pt;
`;

const CommonLogin = ({ header, children }) => {
	return (
		<Holder fluid>
			<Row>
				<Topbar>
					<span>سامانه مدیریت نهاده ها</span>
					<span className='text-center'>اتحادیه تعاونی های عشایری دامداران متحرک ایرانیان</span>
				</Topbar>
			</Row>
			<LoginCard tp={header ? '1rem' : '6rem'}>
				{header ? header : (
					<LogoCircle>
						<Image width={90} height={90} src={InstituteLogo} />
					</LogoCircle>
				)}
				{children}
			</LoginCard>
			<DesignerText>
				Dsigned and Developed by <br />
				ALPHA
			</DesignerText>
		</Holder>
	);
};

export default CommonLogin;
